import { DirectusFile } from '@/app/page.types'
import DirectusImage from './DirectusImage.client'

export default DirectusImage

export function directusBackgroundImage(
  directusFile?: DirectusFile | null,
  replacementBackground = `url("/images/faulty-image.png") center center / 24px no-repeat #0001`,
) {
  return directusFile?.id
    ? { backgroundImage: `url("/.images/${directusFile.id}/")` }
    : { background: replacementBackground }
}
